module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"openMenu":"Open menu","closeMenu":"Close menu"},"es-MX":{"openMenu":"Abrir menú","closeMenu":"Cerrar menú"}}')
  delete Component.options._Ctor
}
